export default __webpack_public_path__ + "static/media/_DSC0388.470220c4.JPG";